import { ParcelSchedulingError } from './ParcelSchedulingError';

export class ParcelSchedulingErrorResponse {
  errors: ParcelSchedulingError[] = [];

  constructor(opts?: Partial<ParcelSchedulingErrorResponse>) {
    if (opts?.errors != null) {
      this.errors = opts.errors.map((val) => new ParcelSchedulingError(val));
    }
  }
}
